<template>
    <page :busy="busy" :tabs="tabs">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatResponseError } from '../../utils/api';
import page from '../generic/page/page.vue';
export default {
    components: { page },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        handleBusy(value) {
            this.busy = value;
        },
        async fetchData() {
            try {
                this.handleBusy(true);
                await this.$store.dispatch('quickbooks/fetchData');
                if (this.quickbooksData.connect_message !== null) {
                    if (this.quickbooksData.connect_message == 'OK') {
                        this.successToast({
                            text: 'Successfully connected to QuickBooks Online.',
                        });
                    } else {
                        this.errorToast({
                            text: this.quickbooksData.connect_message,
                        });
                    }
                }
                if (this.quickbooksData.quickbooks_linked) {
                    this.$store.dispatch('quickbooks/fetchAccountChoices');
                    this.$store.dispatch('quickbooks/fetchAccountMapping');
                    this.$store.dispatch('quickbooks/fetchClassChoices');
                }
            } catch (e) {
                console.log(e);
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch quickbooks data' });
            } finally {
                this.handleBusy(false);
            }
        },
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        ...mapGetters('header', ['isImpersonated']),
        ...mapGetters('quickbooks', ['quickbooksData', 'classChoices', 'toastMessage', 'toastType', 'isSynchronizing']),
        tabs() {
            const tabs = [
                {
                    title: 'Synchronize',
                    route: '/app/quickbooks/synchronize/',
                    active: this.$route.path === '/app/quickbooks/synchronize/',
                },
            ];
            if (this.quickbooksData.quickbooks_linked) {
                tabs.push({
                    title: 'Invoices',
                    route: '/app/quickbooks/objects/',
                    active: this.$route.path === '/app/quickbooks/objects/',
                    titleIcon: {
                        title: 'Synchronizing',
                        src: '/static/images/icons/90-ring-with-bg.svg',
                        hide: !this.isSynchronizing,
                        class: 'quickbooks-spinner',
                    },
                });
                //tabs.push({
                //    title: 'Sync Fail Logs',
                //    route: '/app/quickbooks/sync-fail-logs/',
                //    active: this.$route.path === '/app/quickbooks/sync-fail-logs/',
                //});
                tabs.push({
                    title: 'Account Mapping',
                    route: '/app/quickbooks/account-mapping/',
                    active: this.$route.path === '/app/quickbooks/account-mapping/',
                    disabled: this.isSynchronizing,
                });
                tabs.push({
                    title: 'Account Chart',
                    route: '/app/quickbooks/account-chart/',
                    active: this.$route.path === '/app/quickbooks/account-chart/',
                    disabled: this.isSynchronizing,
                });
                if (this.quickbooksData.has_classes || this.classChoices.length > 0) {
                    tabs.push({
                        title: 'Class Mapping',
                        route: '/app/quickbooks/class-mapping/',
                        active: this.$route.path === '/app/quickbooks/class-mapping/',
                        disabled: this.isSynchronizing,
                    });
                }
                tabs.push({
                    title: 'Settings',
                    route: '/app/quickbooks/settings/',
                    active: this.$route.path === '/app/quickbooks/settings/',
                    disabled: this.isSynchronizing,
                });

                if (this.isImpersonated) {
                    tabs.push({
                        title: 'Error Logs',
                        route: '/app/quickbooks/error-logs/',
                        active: this.$route.path === '/app/quickbooks/error-logs/',
                    });
                }
                //tabs.push({
                //    title: 'Sync Success Logs',
                //    route: '/app/quickbooks/sync-success-logs/',
                //    active: this.$route.path === '/app/quickbooks/sync-success-logs/',
                //});
            }
            return tabs;
        },
    },
    watch: {
        toastMessage(newVal) {
            if (newVal) {
                if (this.toastType === 'success') {
                    this.successToast({ text: newVal });
                } else if (this.toastType === 'error') {
                    this.errorToast({ text: newVal });
                }
                this.$store.commit('quickbooks/clearToast');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.quickbooks-spinner) {
    width: 16px !important;
    height: 16px !important;
}
</style>
